<template>
  <v-col cols="12" class="pl-0 py-0">
    <div class="examination-option-instance">
      <v-row>
          <v-col cols="7">{{ label }}</v-col>
          <v-col cols="5">
            <div class="examination-toggle-wrapper">
              <v-row>
                <v-col cols="5">
                  <input type="radio" v-model="innerVal" value="1"> Yes
                </v-col>
                <v-col cols="5">
                  <input type="radio" v-model="innerVal" value="2"> No
                </v-col>
                <v-col cols="2">
                  <v-icon @click="resetItems(innerVal)" title="Clear Selected" class="sub-item-clear">mdi-autorenew</v-icon>
                </v-col>
              </v-row>
            </div>
          </v-col>
      </v-row>
    </div>
  </v-col>
</template>

<script>
  export default {
    name: 'FormExaminationSubItem',

    props: {
      value: { type: String, default: "" },
      label: { type: String , default: "" }
    },

    data() { 
      return {
        innerVal: this.value
      }
    },

    methods: {
      resetItems() {
        this.innerVal = 0;
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
        this.$emit('check', val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub-item-clear {
    color: #033262;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
  }

  .examination-option-instance {
    min-height: 45px;
    font-size: 14px;
    line-height: 20px;
    border-bottom: 1px solid #ddd;
  }

  .examination-option-instance .col {
    padding: 8px 12px;
  }

  .examination-option-instance * {
    height: auto !important;
  }

  .examination-toggle-wrapper {
    font-size: 10px;
    margin-top: -5px;
  }
</style>